import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil } from '@fortawesome/pro-light-svg-icons'

import { Box, Link } from '@domain-group/suit-theme'

import usePublicationProduct from '@hooks/usePublicationProduct'

const PublicationProductActions = (props) => {
  const { publicationProduct } = props

  const publicationProductPayload = usePublicationProduct(publicationProduct)
  const {
    callbacks: {
      createOrEditPublicationProduct,
    },
  } = publicationProductPayload

  return (
    <Box justifyContent="center">
      <Link greyLink onClick={() => createOrEditPublicationProduct()}>
        <FontAwesomeIcon icon={faPencil} />
      </Link>
    </Box>
  )
}

PublicationProductActions.propTypes = {
  publicationProduct: PropTypes.object.isRequired,
}

export default PublicationProductActions
